<template>
  <div class="bg-white shadow rounded sm:rounded-lg p-4 sm:p-6 max-w-md mx-auto text-center mt-4 sm:mt-8 md:mt-12">

    <img src="/assets/images/mobile.png" class=" w-44  inline-block mb-4">
    <div class="text-center">
      <h4 class="leading-relaxed text-gray-800 text-base sm:text-xl sm:leading-8 font-bold ">
        We have sent an OTP on your
      </h4>
      <h4 class=" font-medium leading-relaxed text-gray-800 text-base  sm:leading-8 gap-1 mb-2 inline-flex">
         phone number: 
          <a href="javascript:void(0)" @click="editPhone = !editPhone" class=" flex justify-between items-center ml-1 cursor-pointer text-indigo-600 ">
            {{user.phone}} 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ml-1 w-4 h-4 text-indigo-600">
              <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
              <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
            </svg>
          </a>
      </h4>
      <div>
        <div>
          <v-the-mask mask="######" type="text" name="phone_verification_code" v-model="phone_verification_code" :masked=false placeholder="Enter OTP code" class="shadow border-gray-400 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:px-4 py-2.5 sm:py-3 text-base sm:text-lg font-medium placeholder-gray-400 rounded-md tracking-wide" :class="{'border-red-500' : errors.phone_verification_code}">
          </v-the-mask>
        </div>

        <div class="text-red-600 text-sm py-3 text-left" v-if="errors.phone_verification_code">
          <i class="fa fa-exclamation-triangle"></i> {{errors.phone_verification_code}}
        </div>
      </div>

      <button type="button" @click="verify()" class="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm sm:text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mt-4 sm:mt-6">
        Verify
      </button>

      <div class="mt-3 sm:mt-4">
        <a href="javascript:void(0);" @click="resendVerificationPhone" class="text-sm sm:text-base font-medium text-indigo-600 underline">
          Resend OTP code
        </a>
      </div>

      <div v-if="resendPhoneSuccessMessage" class="mt-3">
        <p class="text-sm font-medium text-green-600">{{resendPhoneSuccessMessage}}</p>
      </div>
    </div>

    <edit-phone :user="user" v-if="editPhone" v-on:close-edit-phone-modal="closeEditPhoneModal($event)"></edit-phone>
  </div>
</template>

<script>
import UserApi from "@/services/api/User.js";
import { helpers } from "@/mixins/helpers.js";
import EditPhone from "../Modal/EditPhone.vue";
export default {
  props: ["accountNumber", "property", "user"],
  mixins: [helpers],
  components: { EditPhone },
  data() {
    return {
      data: {},
      errors: {},
      editPhone: false,
      resendPhoneSuccessMessage: null,
      phone_verification_code: null,
    };
  },
  methods: {
    resendVerificationPhone() {
      window.blockUI();

      UserApi.resendVerificationPhone(this.accountNumber)
        .then((res) => {
          window.unblockUI();
          this.resendPhoneSuccessMessage =
            "Phone verification code has been sent";
        })
        .finally(() => {
          window.unblockUI();
        });
    },
    validateData() {
      var errors = {};

      let error = false;

      if (!this.phone_verification_code) {
        errors.phone_verification_code =
          "Please enter valid phone verification code";
        error = true;
      }

      if (
        this.phone_verification_code &&
        this.phone_verification_code.length < 6
      ) {
        errors.phone_verification_code =
          "Phone verification code must be of 6 digits";
        error = true;
      }

      this.errors = errors;

      return error;
    },
    // verify() {
    //   if (this.validateData()) return;

    //   UserApi.verifyPhone(this.phone_verification_code, this.accountNumber)
    //     .then((res) => {
    //       window.unblockUI();

    //       if (!res.data.error) {
    //         setTimeout(flash("Your phone has been verified", "success"), 3000);
    //         window.location.href = res.data.redirectUrl;
    //       } else {
    //         var errors = {};
    //         errors.phone_verification_code = res.data.message;
    //         this.errors = errors;
    //       }
    //     })
    //     .finally(() => {
    //       window.unblockUI();
    //     });
    // },

    closeEditPhoneModal(updatedPhone) {
      this.user.phone = updatedPhone;
      this.editPhone = false;
    },
  },
};
</script>

